import * as React from 'react';
import { Spinner } from 'ui-lib';
import loadingCss from './loading.css';

export const LoadingComponent = (props) => {
    return <Spinner className={loadingCss.wrapper} title={props.title} size='large' />;
};
